/*
 * Trust-bar mobile marquee. Spec: docs/trust-bar-spec.md.
 * Extracted to a cached asset (docs/engineering-review.md B1).
 *
 * Performance (2026-10-18): the loop used to run every frame forever, on every width, and read
 * track.scrollWidth each frame (about 2 s of main thread in a Lighthouse run). It now:
 * - caches the loop width and recomputes it only when the row resizes (ResizeObserver);
 * - starts after the window load event, so it never competes with first paint;
 * - runs only while the row is on screen (IntersectionObserver), the tab is visible and the
 *   viewport is below the 1024px breakpoint where the CSS turns the row into a static grid.
 * Motion, speed and the touch pause are unchanged.
 */
(function () {
    // Mobile marquee, ported from the reference (reference-site-DO-NOT-EDIT/src/pages/home.jsx,
    // TrustBar). The row drifts slowly so customers see there is more than one claim, but it
    // stays a real scroll container the finger can drag.
    var SPEED = 26;      // px per second - readable, not distracting
    var PAUSE_MS = 2600; // pause after the customer touches it

    function init() {
      var track = document.querySelector('.kardima-trust-bar__list');
      if (!track) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduced.matches) return;

      var desktop = window.matchMedia('(min-width: 1024px)');
      var last = 0;
      var pausedUntil = 0;
      // Position is tracked here as a float. Reading scrollLeft back each frame loses the
      // sub-pixel remainder to rounding (0.43px/frame at 60fps) and the row never moves.
      var pos = track.scrollLeft;
      var half = track.scrollWidth / 2;
      var onScreen = false;
      var raf = 0;

      function measure() { half = track.scrollWidth / 2; }

      function shouldRun() {
        return onScreen && !desktop.matches && !reduced.matches && half > 0 &&
          document.visibilityState === 'visible';
      }

      function step(now) {
        var dt = Math.min(now - last, 64); // don't lurch after a pause
        last = now;

        if (now <= pausedUntil) {
          pos = track.scrollLeft; // customer is dragging - follow, don't fight
        } else {
          pos += (dt / 1000) * SPEED;
          if (pos >= half) pos -= half; // second copy makes this seamless
          track.scrollLeft = pos;
        }
        raf = requestAnimationFrame(step);
      }

      function update() {
        if (shouldRun()) {
          if (!raf) {
            pos = track.scrollLeft;
            last = performance.now();
            raf = requestAnimationFrame(step);
          }
        } else if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }

      function pause() { pausedUntil = performance.now() + PAUSE_MS; }

      ['touchstart', 'touchmove', 'pointerdown', 'wheel'].forEach(function (evt) {
        track.addEventListener(evt, pause, { passive: true });
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { measure(); update(); }).observe(track);
      } else {
        window.addEventListener('resize', function () { measure(); update(); });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          onScreen = entries[entries.length - 1].isIntersecting;
          update();
        }).observe(track);
      } else {
        onScreen = true;
      }

      document.addEventListener('visibilitychange', update);
      var onMq = function () { measure(); update(); };
      if (desktop.addEventListener) {
        desktop.addEventListener('change', onMq);
        reduced.addEventListener('change', onMq);
      }

      measure();
      update();
    }

    function start() {
      if (document.readyState === 'complete') {
        init();
      } else {
        window.addEventListener('load', init, { once: true });
      }
    }

    start();
  })();
